module.exports = __webpack_public_path__ + "media/performance/doller-icon-42e7dccc.svg";